import {ContentResultUrlClickValueObject} from "../../../../data/value-object/content/ContentResultUrlClickValueObject";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {
    ContentResultUrlClickSearchOption
} from "../../../../data/search-option/content/ContentResultUrlClickSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {ContentResultUrlClickIO} from "../../../../io/ContentIO";
import {ContentResultUrlClickDescription} from "../../../../data/description/content/ContentResultUrlClickDescription";
import {ContentResultUrlClickDescriptor} from "../../../../data/descriptor/content/ContentResultUrlClickDescriptor";
import ListOption from "../../../ListOption";
import {
    ContentResultUrlClickSearchOptionDescription
} from "../../../../data/description/content/ContentResultUrlClickSearchOptionDescription";
import {
    applyContentResultUrlClickSearchOption,
    ContentResultUrlClickSearchOptionField
} from "../../../search-option-field/content/ContentResultUrlClickSearchOptionField";
import ListOrder from "../../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentResultUrlClickValueObject[]>([])
    const option = useStatePair<ContentResultUrlClickSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentResultUrlClickIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentResultUrlClickDescription}
                descriptor={ContentResultUrlClickDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/detailUrls/clicks/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentResultUrlClickSearchOptionDescription}
                fields={ContentResultUrlClickSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentResultUrlClickSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentResultUrlClickDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}